var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AskOkMessage } from "flavr-common";
import { StartTeleportVrMessage } from "../../../messages/locomotion/LocomotionMessages";
import { resolveUid } from "../model/Utils";
import { scriptService } from "../services/ScriptService";
export class ScriptTeleporterManager {
    static teleport(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return;
            try {
                uid = resolveUid(uid);
                yield scriptService.context.connection.askByMessageType(new StartTeleportVrMessage(uid), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
            }
            return false;
        });
    }
}
